export const T = {
  en_GB: {
    noGoals: "No goals yet. Add a goal to get started.",
    addGoal: "+ Add goal",
    delete: "Delete",
    cancel: "Cancel",
    deleteGoal: "Delete Goal",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    cannotDeleteLastGoal: "You must have at least one goal.",
    maxGoalsReached: (max: number) => `You can have a maximum of ${max} goals.`,
    singleGoalFlow: "This flow allows only one goal.",
    error: "Error",
    failedToDeleteGoal: "Failed to delete goal",
    goalDeleted: "Goal deleted",
  },
  nb_NO: {
    noGoals: "Ingen mål ennå. Legg til et mål for å komme i gang.",
    addGoal: "+ Legg til mål",
    delete: "Slett",
    cancel: "Avbryt",
    deleteGoal: "Slett mål",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    cannotDeleteLastGoal: "Du må ha minst ett mål.",
    maxGoalsReached: (max: number) => `Du kan ha maksimalt ${max} mål.`,
    singleGoalFlow: "Denne flyten tillater bare ett mål.",
    error: "Feil",
    failedToDeleteGoal: "Kunne ikke slette mål",
    goalDeleted: "Mål slettet",
  },
} as const;
